import getDashBoardStore from "../../stores/dashboard-store";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import AdminSalary from "./AdminSalary";
import SideBarMenu from "./SideBarMenu";
import UserInfo from "./UserInfo";
import KhattabatCapacity from "./KhattabatCapacity";
import SideBarSearch from "./SideBarSearch";
import { SIDE_BAR_SEARCH_HEIGHT, SIDE_BAR_WIDTH } from "./side-bar-constants";

const SideBar = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  const isAlert = getDashBoardStore().getIsAlert.get();
  return (
    <ET3Div
      isScrollable={true}
      isExtendable={false}
      withShadow={false}
      width={300}
      height={1110}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      color={colors.all.red}
      style={{
        height: "100%",
        minHeight: 0
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={true}
        isExtendable={false}
        withShadow={false}
        width={300}
        height={1110}
        fDirection="column"
        alignItems="flex-start"
        justifyContent="flex-start"
        color={isAlert ? colors.all.red : colors.all.darkSlateGray}
        style={{
          position: "relative",
          overflowX: "hidden",
          height: "100%",
          minHeight: 0
        }}
        onClick={() => {}}
      >
        <Et3Margin top={0} left={0} right={0} bottom={40} />
        <UserInfo />
        <Et3Margin top={0} left={0} right={0} bottom={16} />
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={SIDE_BAR_WIDTH}
          height={SIDE_BAR_SEARCH_HEIGHT}
          fDirection="row"
          alignItems="center"
          justifyContent="center"
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <SideBarSearch />
        </ET3Div>
        <Et3Margin top={0} left={0} right={0} bottom={24} />
        <KhattabatCapacity />
        <AdminSalary />
        <SideBarMenu isAlert={isAlert} />
      </ET3Div>
    </ET3Div>
  );
});
export default SideBar;
